module.exports = __webpack_public_path__ + "img/01.90a27cd8.jpg";